import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp2018',
    ecrans: ['00-2']
});
